import { render, staticRenderFns } from "./PositionOrAnchor.vue?vue&type=template&id=3d61935f&"
import script from "./PositionOrAnchor.vue?vue&type=script&lang=js&"
export * from "./PositionOrAnchor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports